module.exports = __webpack_public_path__ + "img/REFRESH.dee6d20e.svg";